module.exports = __webpack_public_path__ + "static/media/icon-estoque-saida.919e706d.png";